<!--Menu-->
<div class="MainGrid2Col">
	<label>Student ID:</label>
	<label>{{ StudentID }}</label>

	<label>Student Name:</label>
	<label>{{ StudentName }}</label>

	<label>Section:</label>
	<label>{{ Section }}</label>

	<label>Attendance Status:</label>
	<label>{{ Status }}</label>

	<label>Excuse:</label>
	<label>{{ Excuse }}</label>

	<label>Entry Method:</label>
	<label>{{ EntryMethod }}</label>

	<label>Original Date:</label>
	<label>{{ OriginalDate }}</label>

	<label *ngIf="EntryTime != 'Not Defined'">Entry Time:</label>
	<label *ngIf="EntryTime != 'Not Defined'">{{ EntryTime }}</label>

	<label *ngIf="ExitTime != 'Not Defined'">Exit Time:</label>
	<label *ngIf="ExitTime != 'Not Defined'">{{ ExitTime }}</label>

	<label>History Created Date:</label>
	<label>{{ Created }}</label>

	<label>Created By:</label>
	<label>{{ CreatedBy }}</label>

	<label>Staff Type:</label>
	<label>{{ CreatedByType }}</label>

	<label>Staff Title:</label>
	<label>{{ CreatedByTitle }}</label>

	<label>Record Status:</label>
	<label>{{ RecordStatus }}</label>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>
